/**
 * Huge Icons Component
 */
/* tslint:disable:max-line-length */

import * as React from 'react';
import * as BEM from 'react-bem-helper';

function IconWrapper({ children, className, id, ...rest }) {
  const classes = new BEM('huge-icon');

  return <div {...classes('', id, className) } {...rest}>{children}</div>;
}

export function IconLicenseHuge({ className = '', ...props }) {
  return (
    <IconWrapper id="icon-license" className={className} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="95.7" height="118.3" viewBox="0 0 95.7 118.3">
        <g fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10">
          <path className="st0" d="M53.5 2.5H13.8c-3.1 0-5.8 1.1-8 3.3-2.2 2.2-3.3 4.9-3.3 8v90.7c0 7.6 3.8 11.3 11.3 11.3h68c7.6 0 11.3-3.8 11.3-11.3V42.2L53.5 2.5z" />
          <path className="st0" d="M53.5 2.5v39.7h39.7M22.4 60h25.4M22.4 76.1h44.8M22.4 92.2h44.8" />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IconAudioHuge({ className = '', ...props }) {
  return (
    <IconWrapper id="icon-audio" className={className} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="107" height="107" viewBox="0 0 107 107">
        <g fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10">
          <path d="M104.5 70.5H81.8c-3.1 0-5.8 1.1-8 3.3-2.2 2.2-3.3 4.9-3.3 8 0 7.6 3.8 11.3 11.3 11.3h11.3c7.6 0 11.3-3.8 11.3-11.3V70.5zm-68 11.3H13.8c-3.1 0-5.8 1.1-8 3.3-2.2 2.2-3.3 4.9-3.3 8 0 7.6 3.8 11.3 11.3 11.3h11.3c7.6 0 11.3-3.8 11.3-11.3V81.8z" />
          <path d="M36.5 81.8v-68l68-11.3v68" />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IconInvoiceHuge({ className = '', ...props }) {
  return (
    <IconWrapper id="icon-invoice" className={className} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="95.7" height="107" viewBox="0 0 95.7 107">
        <g fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10">
          <path d="M2.5 36.5h90.7M2.5 70.5h90.7M36.5 2.5l-11.3 102M70.5 2.5l-11.3 102" />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IconProjectBoxHuge({ className = '', ...props }) {
  return (
    <IconWrapper id="icon-project-prox" className={className} {...props}>
      <svg width="338" height="363" viewBox="0 0 338 363" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path d="M-31 380h398V-18H-31z"/>
          <path d="M183.773 6.66L316.571 72.91c12.273 6.089 18.42 15.971 18.429 29.646V260.39c-.01 13.68-6.156 23.562-18.43 29.65L183.774 356.29c-9.905 4.948-19.81 4.948-29.714 0L21.257 290.04C8.988 283.87 2.905 273.935 3 260.226v-157.67c.006-13.676 6.147-23.558 18.426-29.647L154.223 6.66c9.852-4.881 19.698-4.881 29.55 0z" stroke="#E4E8ED" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
          <path stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" d="M8 84l160.502 80L329 84M168 355V164M275.677 177.201c-7.271 3.607-13.479 9.181-18.608 16.74L252 201.41l-5.07-2.442c-5.143-2.471-11.35-1.897-18.622 1.695-7.257 3.607-13.464 9.167-18.608 16.74-5.143 7.557-7.7 14.885-7.7 21.969 0 7.083 2.557 11.853 7.7 14.325l5.07 2.442L252 274l37.215-54.729 5.07-7.471c5.143-7.543 7.715-14.871 7.715-21.97 0-7.083-2.572-11.853-7.715-14.324-5.129-2.472-11.336-1.897-18.608 1.695z"/>
        </g>
      </svg>
    </IconWrapper>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/images/Icon/huge-icons.tsx